/**
 * Requests jobs
 * Requests response generated by a tool run
 */
import axios from "axios";
import { defineStore } from "pinia";
import Vue from "vue";
import { getAppRoot } from "@/onload/loadConfig";
export const useJobStore = defineStore("jobStore", {
    state: () => ({
        jobs: {},
        response: {},
    }),
    getters: {
        getJob: (state) => {
            return (jobId) => state.jobs[jobId];
        },
        getLatestResponse: (state) => {
            return state.response;
        },
    },
    actions: {
        async fetchJob(jobId) {
            const { data } = await axios.get(`${getAppRoot()}api/jobs/${jobId}?full=true`);
            this.saveJobForJobId(jobId, data);
        },
        // Setters
        saveJobForJobId(jobId, job) {
            Vue.set(this.jobs, jobId, job);
        },
        saveLatestResponse(response) {
            this.response = response;
        },
    },
});
